import { defaultMaterials } from '../materials/catalog';
import type { FurnitureKind, FurnitureObject, Language, Project, WardrobeSection } from '../types';
import { createId } from '../utils/id';

export function createFurniture(kind: FurnitureKind): FurnitureObject {
  const wardrobe = kind === 'wardrobe';
  const width = wardrobe ? 2400 : 600;
  const sections: WardrobeSection[] = wardrobe
    ? [{ id: createId('section'), width, shelfCount: 0, shelfThickness: 18, hangingRail: false, railHeightFromFloor: 1900, drawerCount: 0, drawerDepth: 450, drawerExtension: 75, shelfAboveDrawers: false }]
    : [];
  return {
    id: createId(kind), kind, name: wardrobe ? 'Wardrobe' : 'Base cabinet', width, height: wardrobe ? 2600 : 720,
    depth: wardrobe ? 600 : 560, panelThickness: 18, backThickness: 3, backEnabled: true, intermediateTopCount: 0, shelfCount: wardrobe ? 0 : 1,
    materialId: 'white', backMaterialId: 'backboard', position: [0, 0, 0], rotation: [0, 0, 0], visible: true,
    doors: { enabled: false, count: 0, open: false, openPanels: [], gap: 2, thickness: 18, opening: 'double' },
    drawers: { count: 0, open: false, openDrawerIds: [], frontHeight: 160, gap: 2, depth: 450 }, sections, panelOverrides: {},
  };
}

export function createProject(name: string, language: Language): Project {
  const now = new Date().toISOString();
  return {
    schemaVersion: 2, id: createId('project'), name, description: '', language, units: 'mm', createdAt: now, updatedAt: now,
    origin: [0, 0, 0], room: { id: createId('room'), name: 'Room', visible: true, width: 4200, length: 3600, height: 2600, wallsVisible: false }, drawings: [],
    furniture: [], groups: [], materials: structuredClone(defaultMaterials), settings: { gridVisible: false, snapEnabled: true, orthoEnabled: false, gridSize: 10 },
  };
}
